import { render, staticRenderFns } from "./process-advancement.vue?vue&type=template&id=f67843f2&scoped=true"
import script from "./process-advancement.vue?vue&type=script&lang=js"
export * from "./process-advancement.vue?vue&type=script&lang=js"
import style0 from "./process-advancement.vue?vue&type=style&index=0&id=f67843f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f67843f2",
  null
  
)

export default component.exports